import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";

// Forgot Password token validation from the email link
const validateToken = async (token) => {

  let status = STATUSES.SUCCESS;
  /*{
    "resetPasswordToken":"",
  }*/
  let body = {
    "resetPasswordToken": token,
  }

  const url = "/api/forgotPwd/validateToken";
  const res = await http.post(url, body, {})
    .then((res) => {
      //console.log("forgot password validateToken()", res);
      return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: error });
    });

  return res;
};

// forgot password get MFA six digit code
const sendSmsFactor = async (token, request) => {

  let status = STATUSES.SUCCESS;

  let body = request;

  const url = "/api/mfa/sendResetPwdUserSmsFactorToken/" + token;
  const res = await http.post(url, body, {
    // headers: {
    //   "Authorization": token
    // }
  }).then((res) => {
    //console.log("sendSmsFactor()", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// verify the email/sms six digit token
const submitMfaForBoth = async (resetPwdToken, mfaToken, type, isEmailVerified) => {

  let status = STATUSES.SUCCESS;

  let body = {
    //"resetPwdToken": resetPwdToken,
    "userFactor": type,
    "token": mfaToken,
    "isEmailVerified": isEmailVerified
  }

  const url = "/api/mfa/verifyResetPwdFactorToken/" + resetPwdToken;
  const res = await http.post(url, body, {
    // headers: {
    //   "Authorization": token
    // }
  }).then((res) => {
    //console.log("submitMfa", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// initial load for Forgot Password Reset Password
const getResetPWDUserInfo = async (token) => {

  let status = STATUSES.SUCCESS;
  /* 
  {
    resetPasswordToken: token
  }
  */
  let body = {
    resetPasswordToken: token
  };

  const url = "/api/pwdToken/loadResetPwd";
  const res = await http.post(url, body, {})
    .then((res) => {

      return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {
      //console.log("getResetPWDUserInfo()", error);
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: error });
    });

  return res;
};

// submit Reset Password for forgot password
const submitResetPassword = async (token, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue) => {
  //console.log("submitResetPassword() axios", token, formInfo, getFieldValue("conNewPassword", formInfo.data));
  //clearErrorMessages(formInfo.data);
  //refer to PasswordResetRequest.java

  var request = {
    resetPasswordToken: token,
    newPwd: getFieldValue("newPassword", formInfo.data),
    confirmPwd: getFieldValue("conNewPassword", formInfo.data),
  }

  var url = "/api/pwdToken/resetPwd";

  var status = STATUSES.SUCCESS;

  const res = await http.post(url, request, {
    // headers: {
    //   "Authorization": token
    // }
  }).then(res => {
    //console.log("submitResetPassword()", res);
    var x = 0;
    var isFirst = false;
    for (const [key, value] of Object.entries(nameConverter)) {

      var d = res.fieldErrors;
      var values = d[key];

      if (values != null) {
        if (x == 0) {
          isFirst = true;
        }
        else {
          isFirst = false;
        }
        addErrorMessages(value, key, res, isFirst);
        status = STATUSES.ERROR;
        x = x + 1;
      }
    }

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    //console.log("error caught from submitResetPassword()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};

// validate reset password for forgot password
const validateResetPassword = async (token, pwd) => {

  let status = STATUSES.SUCCESS;
  let body = {
    "resetPasswordToken": token,
    "newPwd": pwd,
    "confirmPwd": pwd
  };

  const url = "/api/pwdToken/validatePwd";
  const res = await http.post(url, body, {
    // headers: {
    //   "Authorization": token
    // }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {

    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// auto ws pwd generator for activation and forgot password
const getGeneratePWD = async () => {

  let status = STATUSES.SUCCESS;

  const url = "/api/activation/generatePwd";
  const res = await http.post(url, {}, {
    headers: {
      //"Authorization": token
    }
  }).then(res => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    //console.log("getGeneratePWD()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

export { validateToken, sendSmsFactor, getResetPWDUserInfo, submitResetPassword, validateResetPassword, getGeneratePWD, submitMfaForBoth };